
































































import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';
import { AxiosError } from 'axios';
import ALDialog from '@/components/core/Dialog/ALDialog.vue';
import DragDropFileInput from '@/components/common/DragDropFileInput.vue';
import FormRules from '@/mixins/file-upload-rules';
import mixins from '@/utils/mixins';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { ALForm } from '@/common/component.types';

const baseMixins = mixins(FormRules);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'AfterPartsItemImportDialog',

    components: { ALDialog, DragDropFileInput, ErrorAlert },

    props: {
      snapshot: Number
    },

    data: () => ({
      dialog: false,
      file_upload: null as File | null,
      isFileValid: false,

      loading: false,

      errorMessage: '',
      detailErrorMessage: '',

      configurationId: null as null | number
    }),

    watch: {
      dialog(value: boolean) {
        if (!value) {
          this.file_upload = null;
        }
      }
    },

    methods: {
      ...mapActions({
        uploadAfterMarketPartsItems:
          'configuratorConfiguration/uploadAfterMarketPartsItems'
      }),

      close() {
        this.dialog = false;
        this.configurationId = null;
      },

      open(configurationId: number) {
        this.dialog = true;
        this.configurationId = configurationId;
        this.resetFormValidation();
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
      },

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      async uploadAfterMarketPartsItemsHandler() {
        if (this.validateForm()) {
          this.loading = true;
          this.clearAllErrors();
          try {
            await this.uploadAfterMarketPartsItems({
              configurationId: this.configurationId,
              file: this.file_upload,
              snapshot: this.snapshot
            }).then(() => {
              this.file_upload = null;
              this.close();
              this.$emit('uploaded');
            });
          } catch (err) {
            const error = err as AxiosError;
            if (error.response) {
              // client received an error response that falls out of range 2xx
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);

            this.$emit('failed', error);
          } finally {
            this.loading = false;
          }
        }
      }
    }
  });
